"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnalyticsDayDataSortBy = void 0;
var AnalyticsDayDataSortBy;
(function (AnalyticsDayDataSortBy) {
    AnalyticsDayDataSortBy["DATE"] = "date";
    AnalyticsDayDataSortBy["MOST_SALES"] = "most_sales";
})(AnalyticsDayDataSortBy = exports.AnalyticsDayDataSortBy || (exports.AnalyticsDayDataSortBy = {}));
//# sourceMappingURL=analyticsDayData.js.map